import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import RouteWithMeta from "./RouteWithMeta";
import TermsAndCondition from "../pages/terms-condition";
import PrivacyPolicyPage from "../pages/privacy-policy";
import MoneyTransferGuide from "../pages/guide";
import FAQ from "../pages/faq";
import ABOUT from "../pages/about";
import CONTACT from "../pages/contact";
import NotFound from "../pages/404-notFound";
import ScrollToTop from "../components/ScrollToTop";
import DisclaimerPage from "../pages/AffiliateDisclaimer";
import BlogDetail from "../pages/blog-details";
import BlogList from "../pages/blog-list";
import TransferList from "../pages/transfer-hotspot";
import { blogPosts } from "../utils/blogData";
import { transferHotspotData } from "../utils/transferHotspotData";

const Homepage = lazy(() => import("../pages/home"));
const SearchPage = lazy(() => import("../pages/search"));
const ComparisonPage = lazy(() => import("../pages/comparison"));

const domain = "";

const routes = [
    {
        path: "/send-money-to", // Use slug instead of id
        element: <TransferList />,
        isPrivate: false,
        meta: {
            title: "Comparison - MoneyFinder",
            description: "Learn more about us.",
            keywords: "blogs",
            structuredData: {
                "@context": "http://schema.org",
                "@type": "Webpage",
                name: "Comparison",
                url: `${domain}/blogs/:id`,
                description: "Compare exchanges here.",
            },
        },
    },
    {
        path: "/send-money-to/:id", // Use slug instead of id
        element: <BlogDetail getPost={transferHotspotData} />,
        isPrivate: false,
        meta: {
            title: "Comparison - MoneyFinder",
            description: "Learn more about us.",
            keywords: "blogs",
            structuredData: {
                "@context": "http://schema.org",
                "@type": "Webpage",
                name: "Comparison",
                url: `${domain}/blogs/:id`,
                description: "Compare exchanges here.",
            },
        },
    },
    {
        path: "/",
        element: <Homepage />,
        isPrivate: false,
        meta: {
            title: "Compare International Money Transfers Rate | Money Rate Finder ",
            description: "Compare international money transfer services with Money Rate Finder. Get the best exchange rates, low fees, & fast transfers save on every transaction Vist Now!",
            keywords: "home, website, welcome",
            structuredData: {
                "@context": "http://schema.org",
                "@type": "WebPage",
                name: "Home",
                url: `${domain}/`,
                description: "Welcome to our homepage.",
            },
        },
    },
    {
        path: "/search/:slug",
        element: <SearchPage />,
        isPrivate: false,
        meta: {
            title: "Search Results - MoneyFinder",
            description: "Learn more about us.",
            keywords: "about us, our company, information",
            structuredData: {
                "@context": "http://schema.org",
                "@type": "Search Page",
                name: "Search",
                url: `${domain}/search/:slug`,
                description: "Learn more about our company and what we do.",
            },
        },

    },
    {
        path: "/about",
        element: <ABOUT />,
        isPrivate: false,
        meta: {
            title: "Comparing Money Transfer Rates Services | Money Rate finder ",
            description: "Learn about Money Rate Finder and how we help you compare international money transfer services. Find the best rates, lowest fees, and fastest transfers. Compare today!",
            keywords: "about us, our company, information",
            structuredData: {
                "@context": "http://schema.org",
                "@type": "About Page",
                name: "Search",
                url: `${domain}/about`,
                description: "Learn more about our company and what we do.",
            },
        },

    },
    {
        path: "/comparison/:slug", // Use slug instead of id
        element: <ComparisonPage />,
        isPrivate: false,
        meta: {
            title: "Comparison - MoneyFinder",
            description: "Learn more about us.",
            keywords: "comparison",
            structuredData: {
                "@context": "http://schema.org",
                "@type": "Webpage",
                name: "Comparison",
                url: `${domain}/comparison/:slug`,
                description: "Compare exchanges here.",
            },
        },
    },
    {
        path: "/blogs", // Use slug instead of id
        element: <BlogList />,
        isPrivate: false,
        meta: {
            title: "Comparison - MoneyFinder",
            description: "Learn more about us.",
            keywords: "blogs",
            structuredData: {
                "@context": "http://schema.org",
                "@type": "Webpage",
                name: "Comparison",
                url: `${domain}/blogs`,
                description: "Compare exchanges here.",
            },
        },
    },
    {
        path: "/blogs/:id", // Use slug instead of id
        element: <BlogDetail getPost={blogPosts} />, // changes done by Alam
        isPrivate: false,
        meta: {
            title: "Comparison - MoneyFinder",
            description: "Learn more about us.",
            keywords: "blogs",
            structuredData: {
                "@context": "http://schema.org",
                "@type": "Webpage",
                name: "Comparison",
                url: `${domain}/blogs/:id`,
                description: "Compare exchanges here.",
            },
        },
    },
    {
        path: "/terms-condition",
        element: <TermsAndCondition />,
        isPrivate: false,
        meta: {
            title: "Terms and Conditions – Money Rate Finder",
            description: "Review the terms and conditions for using Money Rate Finder’s website and services. Understand your rights and responsibilities. Read our terms today!",
            keywords: "terms, conditions, moneyfinder",
            structuredData: {
                "@context": "https://schema.org",
                "@type": "WebPage",
                name: "Terms and Conditions",
                url: `${domain}/terms-condition`,
                description: "Read the terms and conditions for using MoneyFinder.",
            },
        },
    },
    {
        path: "/privacy-policy",
        element: <PrivacyPolicyPage />,
        isPrivate: false,
        meta: {
            title: "Privacy Policy for Transfer Rates – Money Rate Finder",
            description: "Read Money Rate Finder’s privacy policy to understand how we collect, use, and protect your data. Learn how we ensure your privacy. Review our policy today!",
            keywords: "privacy, policy, data protection",
            structuredData: {
                "@context": "https://schema.org",
                "@type": "WebPage",
                name: "Privacy Policy",
                url: `${domain}/privacy-policy`,
                description: "Learn how we handle your data at MoneyFinder.",
            },
        },
    },
    {
        path: "/guide",
        element: <MoneyTransferGuide />,
        isPrivate: false,
        meta: {
            title: "Money Transfer Guide - MoneyFinder",
            description: "A comprehensive guide to money transfers.",
            keywords: "money transfer, guide, how-to",
            structuredData: {
                "@context": "https://schema.org",
                "@type": "WebPage",
                name: "Money Transfer Guide",
                url: `${domain}/guide`,
                description: "A comprehensive guide to money transfers.",
            },
        },
    },
    // {
    //     path: "/analysis-methodology",
    //     element: <MethodologyAnalysis />,
    //     isPrivate: false,
    //     meta: {
    //         title: "Analysis Methodology | Money Rate Finder Compare Transfer Rates",
    //         description: "Discover how Money Rate Finder’s analysis methodology compares money transfer services, evaluating fees, rates, speed, and more to help you make informed choices.",
    //         keywords: "analysis, methodology, comparison",
    //         structuredData: {
    //             "@context": "https://schema.org",
    //             "@type": "WebPage",
    //             name: "Analysis Methodology",
    //             url: `${domain}/analysis-methodology`,
    //             description: "Understand our analysis methodology for comparing services.",
    //         },
    //     },
    // },
    {
        path: "/faq",
        element: <FAQ />,
        isPrivate: false,
        meta: {
            title: "Get Answers to Your Money Transfer Questions | Money Rate Finder ",
            description: "Got questions about money transfers? Visit Money Rate Finder’s FAQ page for quick answers on fees, exchange rates, and top providers. Find the info you need now!",
            keywords: "FAQ, questions, moneyfinder",
            structuredData: {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                name: "FAQ",
                url: `${domain}/faq`,
                description: "Frequently Asked Questions about MoneyFinder.",
            },
        },
    },
    {
        path: "/contact",
        element: <CONTACT />,
        isPrivate: false,
        meta: {
            title: "Contect Us Get in Touch with Our Team | Money Rate Finder",
            description: "Need help or have questions? Contact Money Rate Finder’s support team for assistance with comparing money transfer Rates . We’re here to help get in touch today!",
            keywords: "about us, our company, information",
            structuredData: {
                "@context": "http://schema.org",
                "@type": "Search Page",
                name: "Search",
                url: `${domain}/contact`,
                description: "Learn more about our company and what we do.",
            },
        },

    },
    {
        path: "/affiliate-disclaimer",
        element: <DisclaimerPage />,
        isPrivate: false,
        meta: {
            title: "Affiliate Disclaimer - MoneyFinder",
            description: "Learn more about us.",
            keywords: "about us, our company, information",
            structuredData: {
                "@context": "http://schema.org",
                "@type": "Search Page",
                name: "Search",
                url: `${domain}/affiliate-disclaimer`,
                description: "Learn more about our company and what we do.",
            },
        },

    },
    {
        path: "/error/404/page-not-found",
        element: <NotFound />,
        isPrivate: false,
        meta: {
            title: "Page Not Found - MoneyFinder",
            description: "The page you are looking for could not be found.",
            keywords: "404, not found, error",
            structuredData: {
                "@context": "https://schema.org",
                "@type": "WebPage",
                name: "Page Not Found",
                url: `${domain}/error/404/page-not-found`,
                description: "The page you are looking for could not be found.",
            },
        },
    },
]


const AllRoutes = () => {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <ScrollToTop />
            <Routes>
                {routes.map(({ path, element, meta }) => (
                    <Route
                        path={path}
                        element={<RouteWithMeta element={element} meta={meta} />}
                        key={path}
                    />
                ))}

                <Route path="*" element={<Navigate to="/error/404/page-not-found" />} />
            </Routes>
        </Suspense>
    );
};

export default AllRoutes;
